import React from 'react';
import useLargeBreakpoint from '../../hooks/useLargeBreakpoint';
import {
  LoadingAccordionItem,
  LoadingButton,
  LoadingDescription,
  LoadingImage,
  LoadingModalHeader,
} from './LoadingComponents';

const CompareCarouselItem = () => (
  <div className="header-item header-item--loading loading-cell">
    <div className="header-item header-item--loading">
      <LoadingImage className="header-item__image loading-image--header-item" />
      <LoadingDescription className="loading-description--padded loading-description--long" />
      <LoadingDescription className="loading-description--padded loading-description--short" />
    </div>
  </div>
);

const LoadingCompareHeader = ({ isAtLeastLarge }) => {
  return (
    <div className="compare-header compare-header--loading">
      {isAtLeastLarge && (
        <div className="grid-placeholder grid-placeholder--loading loading-cell">
          <LoadingDescription className="loading-description--padded loading-description--long" />
          <LoadingDescription className="loading-description--padded loading-description--short" />
        </div>
      )}
      {!isAtLeastLarge && (
        <LoadingDescription className="loading-description--padded loading-description--medium loading-description--disclaimer" />
      )}
      <div className="compare-header__carousel-container">
        <CompareCarouselItem />
        <CompareCarouselItem />
      </div>
      <div className="compare-header__sorting">
        {isAtLeastLarge ? (
          <div className="grid-placeholder loading-component--dark" />
        ) : null}
        <div className="compare-sorting__toggle-option loading-cell loading-component--dark">
          <LoadingDescription className="loading-description--medium" />
        </div>
        <div className="compare-sorting__toggle-option loading-cell loading-component--dark">
          <LoadingDescription className="loading-description--medium" />
        </div>
      </div>
    </div>
  );
};

const LoadingCompareTable = () => (
  <div className="compare-table--loading">
    <LoadingAccordionItem />
    <LoadingAccordionItem />
    <LoadingAccordionItem />
    <LoadingAccordionItem />
    <LoadingAccordionItem />
    <LoadingAccordionItem />
    <LoadingAccordionItem />
  </div>
);

const LoadingCompareFooter = ({ isAtLeastLarge }) => (
  <div className="compare-footer loading-component--dark">
    {isAtLeastLarge && <div className="grid-placeholder"></div>}
    <LoadingButton className="compare-footer__button--loading" />
    <LoadingButton className="compare-footer__button--loading" />
  </div>
);

const LoadingSpecsCompare = () => {
  const isAtLeastLarge = useLargeBreakpoint();
  return (
    <>
      <LoadingModalHeader />
      <LoadingCompareHeader isAtLeastLarge={isAtLeastLarge} />
      <LoadingCompareTable />
      <LoadingCompareFooter isAtLeastLarge={isAtLeastLarge} />
    </>
  );
};

export default LoadingSpecsCompare;
